import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const trackeaseeldConfig: TSPConfig = {
  key: 'trackeaseeld',
  name: 'Trackease ELD',
  imageName: 'trackeaseeld',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Trackease ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default trackeaseeldConfig;
